import BeCuponUtils from "@/utils/Utils";

export default class NotificationSent {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        notificationSentRetrieve(id: ${id}) {
          id
          read
          created
          notifType
          notifBody {
            title
            text
            logo {
              id
              url
            }
          }         
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    // response.data.data.notificationSentRetrieve.fromClient = response.data.data.notificationSentRetrieve.fromClient !== null ? response.data.data.notificationSentRetrieve.fromClient.user.firstName + ' ' + response.data.data.notificationSentRetrieve.fromClient.user.lastName : 'Administrador';
    return response.data.data.notificationSentRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        notificationSentList {
          results {
            id
            type
						title
						users
            created
            fromClient
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i=0; i < response.data.data.notificationSentList.results.length; i++) {
      response.data.data.notificationSentList.results[i].created = BeCuponUtils.formatDateTime(response.data.data.notificationSentList.results[i].created);     
      response.data.data.notificationSentList.results[i].fromClient = (response.data.data.notificationSentList.results[i].fromClient !== null && response.data.data.notificationSentList.results[i].fromClient !== 'null') ? response.data.data.notificationSentList.results[i].fromClient:'Administrador';             
      switch(response.data.data.notificationSentList.results[i].type) {
        case "EM":
          response.data.data.notificationSentList.results[i].type = "EMPRESA";
        break;
        case "CPA":
          response.data.data.notificationSentList.results[i].type = "CUPONERA";
        break; 
        case "CPN":
          response.data.data.notificationSentList.results[i].type = "CUPON";
        break;   
        case "TC":
          response.data.data.notificationSentList.results[i].type = "TIPO CLIENTE";
        break; 
        case "UB":
          response.data.data.notificationSentList.results[i].type = "UBICACION";
        break; 
        default:
          response.data.data.notificationSentList.results[i].type = "---";
        break;                            
      }
    }

    return response.data.data.notificationSentList.results;
  }

  static async fromClient(axios, client) {
    const response = await axios.post(
      '/graphql/',
      `query{
        notificationSentFromClientList(client: ${client}) {
          results {
            id
            type
						title
						users
            created
            fromClient            
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i=0; i < response.data.data.notificationSentFromClientList.results.length; i++) {
      response.data.data.notificationSentFromClientList.results[i].created = BeCuponUtils.formatDateTime(response.data.data.notificationSentFromClientList.results[i].created);      
      switch(response.data.data.notificationSentFromClientList.results[i].type) {
        case "EM":
          response.data.data.notificationSentFromClientList.results[i].type = "EMPRESA";
        break;
        case "CPA":
          response.data.data.notificationSentFromClientList.results[i].type = "CUPONERA";
        break; 
        case "CPN":
          response.data.data.notificationSentFromClientList.results[i].type = "CUPON";
        break;   
        case "TC":
          response.data.data.notificationSentFromClientList.results[i].type = "TIPO CLIENTE";
        break; 
        case "UB":
          response.data.data.notificationSentFromClientList.results[i].type = "UBICACION";
        break; 
        default:
          response.data.data.notificationSentFromClientList.results[i].type = "---";
        break;                            
      }
    }

    return response.data.data.notificationSentFromClientList.results;
  }

  // static async filter(axios, region) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       cityList (region: ${region}){
  //         results {
  //           id
  //           name
  //           latitude
  //           longitude
  //           region {
  //             id
  //             name
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //   return response.data.data.cityList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteNotificationSent(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteNotificationSent.ok;
  }
}